import { FC, useState } from "react";

import { Button, Modal } from "antd";

import styles from "./Users.module.scss";

import { CreateUser } from "@/modules";
import useUsers from "@/hooks/useUsers";
import { UserList } from "@/modules/Users/components";

const Users: FC = () => {
  const [createUserModal, setCreateUserModal] = useState(false);

  const {
    users,
    addNewUser: handleCreateUser,
    editUser,
    deleteUser,
  } = useUsers();

  return (
    <div>
      <Button
        className={styles.createButton}
        type="primary"
        onClick={() => setCreateUserModal(true)}
      >
        Create user
      </Button>
      <UserList
        users={users}
        editUser={editUser}
        deleteUser={deleteUser}
      />
      <Modal
        footer={false}
        visible={createUserModal}
        onCancel={() => setCreateUserModal(false)}
      >
        <CreateUser onCreated={handleCreateUser} />
      </Modal>
    </div>
  );
};

export default Users;
